import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import { Icon, IconButton } from '@mui/material';
import { useUpdateAdsMutation } from 'App/services/adsServiceApi';
import { useGetAllProviderQuery } from 'App/services/providerServiceApi';
import { toast } from 'react-toastify';


const adNames = ["App open", "interstitial", "Native small", "Native medium", "rewarded", "rewarded interstitial"];

export default function AdsEditFormDialogue({ adsEdit }) {
  const [open, setOpen] = React.useState(false);
  const [adsName, setAdsName] = React.useState(adsEdit.adName);
  const [adsContent, setAdsContent] = React.useState(adsEdit.content);
  const [adsStatus, setAdsStatus] = React.useState(adsEdit.adStatus);
  const [providerId, setProviderId] = React.useState(adsEdit.providerId);
  const navigate = useNavigate();

  const { data: providers, error: providersError, isLoading: providersLoading } = useGetAllProviderQuery();
  const [updateAds, { isLoading: updatingAds, isError: updateError, error: updateAdsError }] = useUpdateAdsMutation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditAds = async (event) => {
    event.preventDefault();
    try {
      if(adNames && adsContent){
      await updateAds({ id: adsEdit.id, adName: adsName, content: adsContent, providerId }).unwrap();
      toast.success("Adds Successfully Updated!!")
      handleClose();
      }
      else{
        toast.error("Adds all Field Fill")
      }
    } catch (error) {
      toast.error(error.data.error)
    }
  };
 

  return (
    <React.Fragment>
      <IconButton onClick={handleClickOpen}>
        <Icon>edit</Icon>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleEditAds,
        }}
      >
        <DialogTitle>Edit Ads</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Update the details of the Ad:
          </DialogContentText>

          <Select
            fullWidth
            sx={{ height: 40 }}
            value={adsName}
            onChange={(e) => setAdsName(e.target.value)}
            disabled
          >
            {adNames.map((name) => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}
           

          </Select>
          <TextField
            // required
            margin="dense"
            id="content"
            name="content"
            label="Ads Content"
            type="text"
            fullWidth
            value={adsContent}
            onChange={(e) => setAdsContent(e.target.value)}
            error={!!updateAdsError}
            
          />
          {/* <Select
            // required
            fullWidth
            sx={{ height: 40, mt: 2 }}
            value={adsStatus}
            onChange={(e) => setAdsStatus(e.target.value)}
            displayEmpty
          >
            
            <MenuItem value={1}>Active</MenuItem>
            <MenuItem value={0}>Inactive</MenuItem>
          </Select> */}
          <Select
            required
            fullWidth
            sx={{ height: 40, mt: 2 }}
            value={providerId}
            onChange={(e) => setProviderId(e.target.value)}
            displayEmpty
            disabled
          >
            <MenuItem value="" disabled>Select Provider</MenuItem>
            {providersLoading ? (
              <MenuItem disabled>Loading...</MenuItem>
            ) : providersError ? (
              <MenuItem disabled>Error loading providers</MenuItem>
            ) : (
              providers.map((provider) => (
                <MenuItem key={provider.id} value={provider.id}>
                  {provider.name}
                </MenuItem>
              ))
            )}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" disabled={updatingAds} name="submit">
            Update {updatingAds && 'Loading...'}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
